import { Button, Input, Select } from "antd";
import { useCallback, useEffect, useState } from "react";
import { callNotify } from "../../..";
import InputDuration from "../../../components/Basic/InputDuration2";
import { callEventPopup } from "../../../contexts/PopupContext";
import { firstLetter, showErrorResponse } from "../../../util/varibles/global";
import { ICapability, IServiceTask } from "../../../util/varibles/interface";
import styles from "../style.module.scss";

interface IProps {
    data?: IServiceTask
    nameOk: string
    capabilities: ICapability[]

    onSend(params: any): Promise<IServiceTask>
    onOk(data: IServiceTask): void
}

export default function ServiceTaskForm(props: IProps) {
    const { data, nameOk, capabilities, onSend, onOk } = props;
    const [form, setForm] = useState<Partial<IServiceTask>>(data || {});
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState<any>({});
    const { onClose } = callEventPopup();


    useEffect(() => {


    }, [data])

    const { name: errorName } = error || {};

    const handleChange = (key: string, value?: string | number | { id: string }[]) => {
        setForm(prev => ({ ...prev || {}, [key]: value }))
    }

    const handleSubmit = useCallback(() => {
        if (Object.keys(error).length === 0) {
            setLoading(true)
            const { capabilities = [], ...args } = form;
            onSend({ ...args, capabilities })
                .then(rs => {
                    onOk(rs);
                    setLoading(false)
                    callNotify?.success({ title: nameOk + ' successful' });
                    onClose();
                })
                .catch(() => {
                    showErrorResponse(nameOk + ' failed', error);
                    setLoading(false)
                })
        } else {
            setError(error)
        }
    }, [error, onSend, form, onOk, nameOk, onClose]);

    return <>
        <div className={styles.form}>
            <div className={styles['form-line']}>
                <div data-lev='label'>Task name <span className="color-danger">(*)</span></div>
                <Input className='h-36' value={form.name} onChange={(e: any) => handleChange("name", e.target.value)} />
                {errorName && <div data-lev='error'>{errorName}</div>}
            </div>
            <div className={styles['form-line']}>
                <div data-lev='label'>Estimated duration <span className="text-comment italic">(optional)</span></div>
                <InputDuration className='h-36' borderless={false} value={form.duration} onChange={v => handleChange("duration", v)} />
                {errorName && <div data-lev='error'>{errorName}</div>}
            </div>
            <div className={styles['form-line']}>
                <div className="mb-1 font-[500] text-[15px]">
                    Select equipment to limit this task to vessels that have it. Leave empty to make it available on all service vessels.
                </div>
                <div data-lev='label'>Required equipments <span className="text-comment italic">(optional)</span></div>
                <Select className="select-mode-tag w-full"
                    mode="multiple"
                    value={form.capabilities?.map(item => item.id)}
                    options={capabilities.map(item => ({ label: firstLetter(item.name), value: item.id }))}
                    onChange={v => handleChange('capabilities', v.map(id => ({ id })))}
                />
                {errorName && <div data-lev='error'>{errorName}</div>}
            </div>
        </div>



        <Button
            className={[styles.button, 'bt-primary'].join(' ')}
            data-full={true}
            loading={loading}
            onClick={handleSubmit}
        >
            {props.nameOk}
        </Button>
    </>
}
